export default {
  techs: state => state.techs
}
